"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var VInlineInputEditor_vue_1 = __importDefault(require("../scraps/VInlineInputEditor.vue"));
var VInlineDropdownSelectEditor_vue_1 = __importDefault(require("../scraps/VInlineDropdownSelectEditor.vue"));
var event_bus_1 = require("../../event-bus");
var permissions_json_1 = __importDefault(require("../../../permissions.json"));
var VIcon_vue_1 = __importDefault(require("../scraps/VIcon.vue"));
var DistrictSelect_vue_1 = __importDefault(require("../form/DistrictSelect.vue"));
var UnitNameInput_vue_1 = __importDefault(require("../form/UnitNameInput.vue"));
var DeleteUnit_vue_1 = __importDefault(require("./DeleteUnit.vue"));
var __ = window.$lang;
exports.default = vue_1.default.extend({
    name: "units-table",
    components: {
        VInlineInputEditor: VInlineInputEditor_vue_1.default,
        VInlineDropdownSelectEditor: VInlineDropdownSelectEditor_vue_1.default,
        VIcon: VIcon_vue_1.default,
        DeleteUnit: DeleteUnit_vue_1.default
    },
    props: {
        units: {
            type: Array,
            required: true
        },
        pagination: {
            type: Object,
            required: true
        },
        districts: {
            type: Array,
            required: true
        }
    },
    data: function () {
        return {
            permissions: permissions_json_1.default,
            headers: [
                __("Lp."),
                __("Nazwa jednostki"),
                __("Hufiec"),
                __("Akcje")
            ],
            components: {
                UnitNameInput: UnitNameInput_vue_1.default,
                DistrictSelect: DistrictSelect_vue_1.default
            }
        };
    },
    methods: {
        onUnitRename: function (unit_id, name) {
            event_bus_1.EventBus.$emit(event_bus_1.events.unit.rename, { id: unit_id, name: name });
        },
        onUnitDistrictUpdate: function (unit_id, option) {
            event_bus_1.EventBus.$emit(event_bus_1.events.unit.district.update, {
                id: unit_id,
                district_id: option.value
            });
        }
    }
});
